import axios from 'axios'
import {StockMovementReportTableModel} from '../models/StockMovementReportModel'

const API_URL = process.env.REACT_APP_API_URL
const STOCK_REPORT_URL = `${API_URL}/stock-movement-report`

export function findAll(params: StockMovementReportTableModel) {
  return axios.get(STOCK_REPORT_URL, {params})
}
